import { PersistentStorageStrategyFactory } from './factories';
import { localStorageStrategy } from './strategies';
var resolver = new PersistentStorageStrategyFactory();
resolver.register(localStorageStrategy);
export var localStorage = resolver.getStrategy().storageInstance();
